<script setup>
import { ref, computed, watch } from 'vue'
import { Sheet, SheetContent } from '@/components/ui/sheet'
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group"
import { Label } from "@/components/ui/label"
import { Button } from "@/components/ui/button"
import { ArrowLeft } from "lucide-vue-next"
import {bus, getDateUTC, validateProjectDuration, isBookingInProject, cleanx, germanToISO, formatDateYYYYMMDD, popupProjectsList, getResourceRange, formatDateDDMMYYYY, is_bookable} from "./planner.js";
import DateInput from "./DateInput.vue"
import Personlist from "./Personlist.vue"

defineExpose({
  handleSelectionComplete,
  handleSelectionClose,
})

const emit = defineEmits(['bookingDone', 'dateupdate', 'close'])

const props = defineProps({projects: { type: Array, required: true },
                           users: { type: Array, required: true },
						   bookings: { type: Array, required: true },
                           xScale: {type: Function, required: true},
						   days: { type: Array, required: true}});

const selectedDays      = ref([]);
const selectedResources = ref([]);
const selectedPid       = ref(null);
const startDate = ref("31-12-1964");
const endDate = ref("31-12-1964");

let freeup = { id: -1, name: 'Freimachen', color: 'lightgray' }

function handleDateUpdate(start, end) {
	console.log("start=" + start)
	console.log("end=" + end)
	let isoFirst = germanToISO(start) + "T00:00:00.000Z"
	let isoLast  = germanToISO(end) + "T00:00:00.000Z"
	console.log("isoFirst=" + isoFirst)
	console.log("isoLast=" + isoLast)
	selectedDays.value=[new Date(isoFirst), new Date(isoLast)];
	emit('dateupdate', start, end);	
}

function handleDateUpdateStart(start) {
	startDate.value = start
	handleDateUpdate(start, endDate.value);
}

function handleDateUpdateEnd(end) {
	endDate.value = end;
	handleDateUpdate(startDate.value, endDate.value);
}

const showPopup          = ref(false);

// Schließt sich das Sheet (z.B. durch Tippen/Klicken außerhalb), muss auch die
// blaue Auswahl im Planer geräumt werden – das übernimmt der Parent via closeSelection().
watch(showPopup, (open) => {
  if (!open) emit('close')
})
const containsBookings   = ref(false);
const showBookingOptions = ref(false);

const orientation = computed(() =>
  window.innerWidth > window.innerHeight ? 'landscape' : 'portrait'
)

let projects = ref([]);

function checkSelectionInProject(p, sel) {
  let isIn = isBookingInProject(p, sel)
  console.log("checkSelectionInProject p=" + JSON.stringify(p) + " sel=" + JSON.stringify(sel) + " isIn=" + isIn)
  return isIn;
}
// Called when selection box is completed
function handleSelectionComplete(b) {
  selectedDays.value = computeSelectedDays(b);
  console.log("handleSelectionComplete selectedDays.value=" + selectedDays.value)
  if (selectedDays.value.length <= 0) {
	return;
  }


  let firstDay = selectedDays.value[0];
  let lastDay  = selectedDays.value.at(-1);
  console.log("selectedDays=" + JSON.stringify(selectedDays.value))
  console.log("firstDay=" + firstDay + " lastDay=" + lastDay)
  
  let isoFirst = formatDateYYYYMMDD(firstDay) + "T00:00:00.000Z"
  let isoLast  = formatDateYYYYMMDD(lastDay) + "T00:00:00.000Z"
  startDate.value = formatDateDDMMYYYY(firstDay);
  endDate.value = formatDateDDMMYYYY(lastDay);
  projects.value =  popupProjectsList(props.projects).filter(p => checkSelectionInProject(p, {start: new Date(isoFirst), end: new Date(isoLast)}));
  console.log("isoFirst=" + isoFirst)
  console.log("isoLast=" + isoLast)
  console.log("startDate=" + startDate.value)
  console.log("endDate=" + endDate.value)

  const timesheet = document.getElementById("timesheet");
  let [selected_resources, selected_pid] = getResourceRange(b, props.users, timesheet);
  console.log("selected_resources=" + JSON.stringify(selected_resources.map(u => (u.id + ":" + u.short))));
  console.log("selected_pid=" + selected_pid);

  if (selected_resources == null || selected_pid == null) {
	return
  }
  selectedResources.value = selected_resources;
  selectedPid.value = selected_pid;
  containsBookings.value = props.bookings.some(b => selected_resources.some(u => u.id === b.user_id) && is_bookable(b, selectedDays.value));
  console.log("containsBookings.value=" + containsBookings.value);
  showPopup.value = true
}

function handleSelectionClose() {
  selectedResources.value = [];
  showPopup.value = false
}

function computeSelectedDays(box) {
  const [x1, x2] = [box.x, box.x + box.width].sort((a, b) => a - b)

  const selectedDays = props.days.filter(day => {
    const dayX = cleanx(props.xScale, day);
    return dayX > x1 && dayX <= x2
  })
  
  return selectedDays
}

async function selectAction(option) {
	
  let action = option.id;
  
  let sdays = selectedDays.value;
  let firstDay = sdays.at(0);
  let lastDay  = sdays.at(-1);
  console.log("sdays=" + JSON.stringify(sdays));
  console.log("firstDay=" + firstDay.toUTCString() + " type=" + typeof firstDay);
  console.log("lastDay=" + lastDay.toUTCString() + " type=" + typeof lastDay);

  let validate = false;
  let extend = false;
  let newpstart = null;
  let newpend = null;

  if (action >= 0) {
	let project = props.projects.find(p => p.id === parseInt(selectedPid.value));
	[validate, extend, newpstart, newpend] = validateProjectDuration(project, getDateUTC(firstDay), getDateUTC(lastDay));
	if (!validate) {
		return;
	}
  }

  const params = {
	booking_action: action,
	selected_pid: parseInt(selectedPid.value), 
	firstDay: firstDay,
	lastDay: lastDay,
	newpstart: extend ? newpstart : null,
	newpend: extend ? newpend : null,
	selectedResources: selectedResources.value.map(u => u.id),
  }
  showPopup.value = false
  showBookingOptions.value = false
  emit('bookingDone', params);
  
  if (action >= 0) {
    bus.emit('project-updated', params);
  }
}

function bookProject(val) {
  showBookingOptions.value = val;
}

const selectedOption = ref(null);
</script>

<template>
	<Sheet class="test" v-model:open="showPopup">
	  <SheetContent :side="orientation === 'landscape' ? 'right' : 'bottom'" class="booking-select p-4 w-64 max-w-full overflow-y-auto" style="z-Index: 10000 !important">
		<div v-if="!showBookingOptions">
		  <h3 v-if="containsBookings"  class="text-lg font-semibold mb-2">Was möchten Sie mit dem ausgewählten Bereich tun?</h3>
	      <h3 v-if="!containsBookings" class="text-lg font-semibold mb-2">Neue Buchung in {{props.projects.find(p => p.id === selectedPid).name}}</h3>
		  <Personlist label="Personen:" :words="selectedResources.map(r => r.short)" />
		  <div class="spacer"/>
		  
		  <!-- A dummy input box so that when the component opens up in Safari -->
		  <!-- it does not automatically open up the date picker!! Impossible to quell any other way -->
		  <!-- the first focal point of the browser will be the dummy -->
		  <input style="display: none;" />
		  <!-- end of hack -->
		  
		  <DateInput label="Start" :modelValue="startDate" :max="endDate" @datechange="handleDateUpdateStart" />
		  <div class="spacer"/>
		  <DateInput label="Ende"  :modelValue="endDate" :min="startDate" @datechange="handleDateUpdateEnd" />

		  <div class="spacer"/>

		  <button v-if="containsBookings"
		    class="w-full flex items-center space-x-2 text-center timin_text_center px-3 py-2 bg-timin hover:brightness-90 text-black"
		    @click="selectAction(freeup)"
	      >
		    <span>{{ freeup.name }}</span>
		  </button>

		  <div class="spacer"/>

		  <button 
		    class="w-full flex items-center space-x-2 text-center timin_text_center px-3 py-2 bg-timin hover:brightness-90 text-black"
		    @click="bookProject(true)"
			style="font-size: 97%;"
		  >
		    <span>In anderem Projekt buchen</span>
		  </button>

		  <div class="spacer"/>

		  <button
		    class="w-full flex items-center space-x-2 text-center timin_text_center px-3 py-2 bg-timin hover:brightness-90 text-black"
		    @click="selectAction({id: selectedPid})"
		  >
		    <span>Im Projekt buchen</span>
		  </button>

		</div>
		<div v-if="showBookingOptions">
          <Button variant="outline" class="flex items-center gap-2"
			 @click="bookProject(false)">
			<ArrowLeft class="w-4 h-4" />
		  </Button>
		  <h3 class="text-lg font-semibold mb-2">In welches Projekt möchten Sie die Buchungen verschieben?</h3>

		  <div class="flex flex-col space-y-4 w-64">
			<RadioGroup v-model="selectedOption" class="flex flex-col space-y-3">
			<div
				v-for="option in projects.filter(p => is_bookable(p, selectedDays))"
				:key="option.id"
				class="flex items-center space-x-2"
			>
				<RadioGroupItem
				:id="`project-${option.id}`"
				:value="option.id"
				/>
				<Label
				:for="`project-${option.id}`"
				:style="{
					backgroundColor: option.color,
					color: 'black',
					height: '25px',
					display: 'flex',
					flex: 0.5,
					alignItems: 'center',
					paddingLeft: '10px'
				}"
				>
				{{ option.name }}
				</Label>
			</div>
			</RadioGroup>
			<Button @click="selectAction({id: selectedOption})" :disabled="selectedOption == null">
			  Verschieben
			</Button>
		  </div>

	  </div>
	  </SheetContent>
	</Sheet>
</template>

<style scoped>
.timin_text_center {
	justify-content: center;
}
</style>